module.exports = __webpack_public_path__ + "img/ic_32_register_apple-active.969428e8.svg";